/**
 * Gets string as input and returns bool whether email is valid or not
 * @param {string} str
 * @returns {bool}
 */
const regexEmail = (str) => {
  let strRegex = "";
  strRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if (strRegex.test(str) || str.length === 0) return true;
  else return false;
};

/**
 * Gets string as input and returns bool whether password is valid or not
 * @param {string} str
 * @returns {bool}
 */
const regexPassword = (str) => {
  let strRegex = "";
  strRegex = /^(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,15}$/;

  if (strRegex.test(str) || str.length === 0) return true;
  else return false;
};

export {
  regexEmail,
  regexPassword
};
